import { createBrowserRouter, Navigate } from "react-router-dom";
import AnalyticsLayout from "../components/Analytics/AnalyticsLayout";
import HomeModern from "../components/Pages/HomeModern/HomeModern";
import NzCombatSports from "../components/Pages/NzCombatSports/NzCombatSports";
import VideoSearch from "../components/Pages/VideoSearch/VideoSearch";
import Contact from "../components/Pages/Contact/Contact";
import Profile from "../components/Pages/Profile/Profile";
import ManageAccount from "../components/Pages/Profile/ManageAccount";
import Subscribe from "../components/Pages/Subscribe/Subscribe";
import LoginRoute from "../components/Pages/Login/LoginRoute";
import Join, { LegacyJoinRedirect } from "../components/Pages/Join/Join";
import WatchPage from "../components/Pages/VideoPage/WatchPage";
import PaymentCompleted from "../components/Pages/PaymentCompleted/PaymentCompleted";
import SubscriptionDetails from "../components/Pages/Subscribe/SubscriptionDetails";
import MyLibrary from "../components/Pages/MyLibrary/MyLibrary";
import PurchaseSuccess from "../components/Pages/PurchaseSuccess/PurchaseSuccess";
import { Routes } from "../types/constants";
import ChangePassword from "../components/Pages/ChangePassword";
import ForgotPassword from "../components/Pages/ForgotPassword/ForgotPassword";
import ResetPassword from "../components/Pages/ForgotPassword/ResetPassword";
import FightCards from "../components/Pages/FightCards/FightCards";
import FightCardEvent from "../components/Pages/FightCards/FightCardEvent";
import AdminLayout from "../components/Pages/Admin/AdminLayout";
import AdminHighlights from "../components/Pages/Admin/AdminHighlights";
import AdminCollections from "../components/Pages/Admin/AdminCollections";
import AdminEvents from "../components/Pages/Admin/AdminEvents";
import AdminLocations from "../components/Pages/Admin/AdminLocations";
import AdminPromos from "../components/Pages/Admin/AdminPromos";
import AdminImages from "../components/Pages/Admin/AdminImages";
import AdminTags from "../components/Pages/Admin/AdminTags";
import AdminEventTypes from "../components/Pages/Admin/AdminEventTypes";
import AdminParticipants from "../components/Pages/Admin/AdminParticipants";
import AdminParticipantAttributes from "../components/Pages/Admin/AdminParticipantAttributes";
import AdminParticipantAttributeValues from "../components/Pages/Admin/AdminParticipantAttributeValues";
import AdminUsers from "../components/Pages/Admin/AdminUsers";
import AdminUserCreate from "../components/Pages/Admin/AdminUserCreate";
import AdminUserDetail from "../components/Pages/Admin/AdminUserDetail";
import AdminUserWatchHistory from "../components/Pages/Admin/AdminUserWatchHistory";
import AdminVideoParticipantTypes from "../components/Pages/Admin/AdminVideoParticipantTypes";
import AdminVideoParticipants from "../components/Pages/Admin/AdminVideoParticipants";
import AdminVideos from "../components/Pages/Admin/AdminVideos";
import AdminVideoList from "../components/Pages/Admin/AdminVideoList";
import AdminSiteConfiguration from "../components/Pages/Admin/AdminSiteConfiguration";
import AdminEmailLogs from "../components/Pages/Admin/AdminEmailLogs";
import AdminPaymentDisputes from "../components/Pages/Admin/AdminPaymentDisputes";
import AdminPaymentOperations from "../components/Pages/Admin/AdminPaymentOperations";
import AdminAnalytics from "../components/Pages/Admin/AdminAnalytics";
import AdminVideoAnalytics from "../components/Pages/Admin/AdminVideoAnalytics";
import AdminVideoPlayback from "../components/Pages/Admin/AdminVideoPlayback";
import AdminContentProcessingConfig from "../components/Pages/Admin/AdminContentProcessingConfig";
import AdminContentProcessingActivity from "../components/Pages/Admin/AdminContentProcessingActivity";
import AdminDiagnostics from "../components/Pages/Admin/AdminDiagnostics";
import AdminStorageBrowser from "../components/Pages/Admin/AdminStorageBrowser";

const router = createBrowserRouter([
    {
        element: <AnalyticsLayout />,
        children: [
            {
                path: '/',
                element: <HomeModern />
            },
            {
                path: Routes.VIDEO_SEARCH,
                element: <Navigate to={Routes.VIDEOS} replace />
            },
            {
                path: Routes.VIDEOS,
                element: <VideoSearch />
            },
            {
                path: Routes.NZ_COMBAT_SPORTS,
                element: <NzCombatSports />
            },
            {
                path: Routes.FIGHT_CARDS,
                element: <FightCards />
            },
            {
                path: `${Routes.FIGHT_CARD_EVENT}/:eventId`,
                element: <FightCardEvent />
            },
            {
                path: Routes.WATCH,
                element: <WatchPage />
            },
            {
                path: '/contact',
                element: <Contact />
            },
            {
                path: '/profile',
                element: <Profile />
            },
            {
                path: Routes.PROFILE_BILLING,
                element: <SubscriptionDetails />
            },
            {
                path: Routes.PROFILE_MANAGE_ACCOUNT,
                element: <ManageAccount />
            },
            {
                path: Routes.MY_PURCHASES,
                element: <Navigate to={`${Routes.MY_LIBRARY}?tab=purchases`} replace />
            },
            {
                path: Routes.MY_LIBRARY,
                element: <MyLibrary />
            },
            {
                path: '/pricing',
                element: <Subscribe />
            },
            {
                path: '/login',
                element: <LoginRoute />
            },
            {
                path: Routes.JOIN,
                element: <Join />
            },
            {
                path: '/register',
                element: <LegacyJoinRedirect source="legacy_register" />
            },
            {
                path: '/payment_completed',
                element: <PaymentCompleted />
            },
            {
                path: '/purchase-success',
                element: <PurchaseSuccess />
            },
            {
                path: '/payment_form',
                element: <LegacyJoinRedirect source="legacy_payment" />
            },
            {
                path: '/subscription_details',
                element: <Navigate to={Routes.PROFILE_BILLING} replace />
            },
            {
                path: '/change_password',
                element: <ChangePassword />
            },
            {
                path: '/forgot_password',
                element: <ForgotPassword />
            },
            {
                path: '/reset_password',
                element: <ResetPassword />
            },
            {
                path: Routes.ADMIN,
                element: <AdminLayout />,
                children: [
                    {
                        index: true,
                        element: <Navigate to={Routes.ADMIN_ANALYTICS} replace />
                    },
                    {
                        path: 'analytics',
                        element: <AdminAnalytics />
                    },
                    {
                        path: 'video-analytics',
                        element: <AdminVideoAnalytics />
                    },
                    {
                        path: 'video-playback',
                        element: <AdminVideoPlayback />
                    },
                    {
                        path: 'diagnostics',
                        element: <AdminDiagnostics />
                    },
                    {
                        path: 'storage',
                        element: <AdminStorageBrowser />
                    },
                    {
                        path: 'highlights',
                        element: <AdminHighlights />
                    },
                    {
                        path: 'collections',
                        element: <AdminCollections />
                    },
                    {
                        path: 'events',
                        element: <AdminEvents />
                    },
                    {
                        path: 'promos',
                        element: <AdminPromos />
                    },
                    {
                        path: 'images',
                        element: <AdminImages />
                    },
                    {
                        path: 'tags',
                        element: <AdminTags />
                    },
                    {
                        path: 'users',
                        element: <AdminUsers />
                    },
                    {
                        path: 'users/new',
                        element: <AdminUserCreate />
                    },
                    {
                        path: 'users/:userId/watch-history',
                        element: <AdminUserWatchHistory />
                    },
                    {
                        path: 'users/:userId',
                        element: <AdminUserDetail />
                    },
                    {
                        path: 'event-types',
                        element: <AdminEventTypes />
                    },
                    {
                        path: 'locations',
                        element: <AdminLocations />
                    },
                    {
                        path: 'participants',
                        element: <AdminParticipants />
                    },
                    {
                        path: 'participant-attributes',
                        element: <AdminParticipantAttributes />
                    },
                    {
                        path: 'participant-attribute-values',
                        element: <AdminParticipantAttributeValues />
                    },
                    {
                        path: 'video-participant-types',
                        element: <AdminVideoParticipantTypes />
                    },
                    {
                        path: 'video-participants',
                        element: <AdminVideoParticipants />
                    },
                    {
                        path: 'videos',
                        element: <AdminVideoList />
                    },
                    {
                        path: 'videos/new',
                        element: <AdminVideos />
                    },
                    {
                        path: 'videos/:videoId',
                        element: <AdminVideos />
                    },
                    {
                        path: 'video-upload',
                        element: <Navigate to={Routes.ADMIN_VIDEO_NEW} replace />
                    },
                    {
                        path: 'site-configuration',
                        element: <AdminSiteConfiguration />
                    },
                    {
                        path: 'services/content-processing/config',
                        element: <AdminContentProcessingConfig />
                    },
                    {
                        path: 'services/content-processing/activity',
                        element: <AdminContentProcessingActivity />
                    },
                    {
                        path: 'payment-operations',
                        element: <AdminPaymentOperations />
                    },
                    {
                        path: 'payment-disputes',
                        element: <AdminPaymentDisputes />
                    },
                    {
                        path: 'email-logs',
                        element: <AdminEmailLogs />
                    }
                ]
            },
            {
                path: "*",
                element: <Navigate to="/" replace />
            }
        ]
    }
]);

export default router;
